import { render, staticRenderFns } from "./SearchBusiness.vue?vue&type=template&id=2d87ef47&scoped=true&"
import script from "./SearchBusiness.vue?vue&type=script&lang=js&"
export * from "./SearchBusiness.vue?vue&type=script&lang=js&"
import style0 from "./SearchBusiness.vue?vue&type=style&index=0&id=2d87ef47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87ef47",
  null
  
)

export default component.exports